module.exports = __webpack_public_path__ + "img/rateLev_0.523f2e5e.svg";